import { Icon } from './Icon';

export default function EmptyState({ icon = 'info', title, message, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="mb-3 rounded-full bg-neutral-100 p-3 text-neutral-400">
        <Icon name={icon} className="h-6 w-6" />
      </div>
      <h3 className="text-sm font-semibold text-neutral-900">{title}</h3>
      {message && <p className="mt-1 text-sm text-neutral-500 max-w-md">{message}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
